import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ruIcon from '../../assets/img/icons/ru.svg'
import esIcon from '../../assets/img/icons/es.svg'
import inIcon from '../../assets/img/icons/in.svg'
import itIcon from '../../assets/img/icons/it.svg'
import usIcon from '../../assets/img/icons/us.svg'
import vnIcon from '../../assets/img/icons/vn.svg'

const StyledCircleFlag = styled.img`
	font-size: 22px;
    z-index: 1;
    border: 1px solid #7E7E7E;
    border-radius: 45px;
`

class CircleFlag extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            link: '',
        }
        this.setLink = this.setLink.bind(this)
    }

    setLink(countryCode) {
        switch (countryCode) {
            case 'us':
                return usIcon
            case 'es':
                return esIcon
            case 'in':
                return inIcon
            case 'hi':
                return inIcon
            case 'it':
                return itIcon
            case 'ru':
                return ruIcon
            case 'vi':
                return vnIcon
            case 'vn':
                return vnIcon
            default:
                break
        }
    }

    componentDidMount() {
        this.setState({link: this.setLink(this.props.countryCode)})
    }

    render() {
        let link = this.state.link
        if (!link) link = this.setLink(this.props.countryCode)
        return (
            <React.Fragment>
                {
                    link ?
                        <StyledCircleFlag title={this.props.countryCode} src={link} alt="" {...this.props} />
                        : ''
                }
            </React.Fragment>
        )
    }
}

CircleFlag.propTypes = {
    countryCode: PropTypes.string,
}

export default CircleFlag



// WEBPACK FOOTER //
// ./src/components/Header/CircleFlag.jsx